export var FormStatus;
(function (FormStatus) {
    //草稿
    FormStatus[FormStatus["DRAFT"] = 0] = "DRAFT";
    // 进行中
    FormStatus[FormStatus["PROCESSING"] = 1] = "PROCESSING";
    // 已取消
    FormStatus[FormStatus["CANCELLED"] = 2] = "CANCELLED";
    // 已完成
    FormStatus[FormStatus["COMPLETED"] = 3] = "COMPLETED";
})(FormStatus || (FormStatus = {}));
export var FormStatusZh;
(function (FormStatusZh) {
    FormStatusZh["DRAFT"] = "\u8349\u7A3F";
    FormStatusZh["PROCESSING"] = "\u8FDB\u884C\u4E2D";
    FormStatusZh["CANCELLED"] = "\u5DF2\u53D6\u6D88";
    FormStatusZh["COMPLETED"] = "\u5DF2\u5B8C\u6210";
})(FormStatusZh || (FormStatusZh = {}));
export var FormStatusEn;
(function (FormStatusEn) {
    FormStatusEn["DRAFT"] = "DRAFT";
    FormStatusEn["PROCESSING"] = "PROCESSING";
    FormStatusEn["CANCELLED"] = "CANCELLED";
    FormStatusEn["COMPLETED"] = "COMPLETED";
})(FormStatusEn || (FormStatusEn = {}));
export var FormStatusZhToEn;
(function (FormStatusZhToEn) {
    FormStatusZhToEn["\u8349\u7A3F"] = "DRAFT";
    FormStatusZhToEn["\u8FDB\u884C\u4E2D"] = "PROCESSING";
    FormStatusZhToEn["\u5DF2\u53D6\u6D88"] = "CANCELLED";
    FormStatusZhToEn["\u5DF2\u5B8C\u6210"] = "COMPLETED";
})(FormStatusZhToEn || (FormStatusZhToEn = {}));
